/**
 * If `String.prototype.normalize` is supported it normalizes diacritics by
 * replacing them with "clean" character from received text.
 * @example
 * normalizeDiacritics('Olá, você aí');
 * //=> 'Ola, voce ai'
 * @param {string} text - A `string` value.
 * @returns {string}
 */
var normalizeDiacritics = function (text) {
    return !!String.prototype.normalize
        ? text.normalize('NFKD').replace(/[\u0300-\u036F]/g, '')
        : text;
};
export default normalizeDiacritics;
//# sourceMappingURL=normalizeDiacritics.js.map